import { PeerReviewViewModel } from "../../peerReviews/peerReviewsApiSlice";

export interface Props {
	draftId: number;
	readonly: boolean;
	peerReviews: PeerReviewViewModel[];
	className?: string;
}

export default function PeerReviews(props: Props) {
	return (
		<>
			{props.peerReviews.map((pr, index) => {
				return (
					<>
						<h4>{`Peer Review ${index + 1}`}</h4>
						<p className="text-sm">{`by ${pr.reviewer}`} (avatar)</p>
						<table className="tbl tbl-data mt-4">
							<thead>
								<tr>
									<th>Review Question</th>
									<th>Comment</th>
								</tr>
							</thead>
							<tbody>
								{pr.questions.map((q, index) => {
									return (
										<tr key={q.id}>
											<td>{q.question}</td>
											<td>{q.comment}</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					</>
				);
			})}
		</>
	);
}
